import { type ChatHistoryItemType } from '@/components/chat';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { getContactInitials } from './contacts/contactUtils';
import { cn } from '@/utils/helpers';

export interface ConversationHistoryItemType extends ChatHistoryItemType {
  participantsNames?: string[];
  ownerName: string;
}

interface ConversationHistoryItemProps extends ConversationHistoryItemType {
  onClick: () => void;
}

const getAvatarContent = (names: string[], ownerName: string) => {
  if (names.length === 1) {
    return <span className="text-sm font-medium">{getContactInitials(names[0])}</span>;
  }

  if (names.length > 1) {
    return (
      <div className="flex w-full h-full">
        <div className="flex-1 flex items-center justify-center text-sm font-medium border-r border-gray-300">
          {names[0].charAt(0).toUpperCase()}
        </div>
        <div className="flex-1 flex items-center justify-center text-sm font-medium">
          {names[1].charAt(0).toUpperCase()}
        </div>
      </div>
    );
  }

  return <span className="text-sm font-medium">{ownerName.charAt(0).toUpperCase()}</span>;
};

export function ConversationHistoryItem({
  id,
  title,
  isActive,
  onClick,
  participantsNames = [],
  ownerName,
}: ConversationHistoryItemProps) {
  return (
    <Button
      key={id}
      onClick={onClick}
      variant="ghost"
      className={cn(
        'w-full gap-3 px-0 text-left h-auto !justify-start rounded-sm text-text-primary font-normal',
        isActive ? 'bg-accent font-semibold' : 'border-b border-gray-200'
      )}
      data-testid={`chat-history-item-${id}`}
      title={title}
    >
      <Avatar className="w-10 h-10 text-gray-500">
        <AvatarFallback>{getAvatarContent(participantsNames, ownerName)}</AvatarFallback>
      </Avatar>
      <div className="truncate text-sm">{title}</div>
    </Button>
  );
}
